export default function Referrals() {
    return (
        <div className="flex flex-col items-center justify-center py-20 bg-white/[0.03] border border-white/[0.08] rounded-2xl backdrop-blur-xl">
            <div className="w-16 h-16 bg-white/[0.05] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-gift-line text-3xl text-zinc-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">Referrals & Rewards</h3>
            <p className="text-zinc-500 max-w-md text-center">
                Invite friends and earn premium interview sessions. The referral program is launching soon.
            </p>
        </div>
    );
}
